import React from "react";
import Icon1 from "../icons/Icon"; // Assuming you have an Icon component
import { getRoleString } from "../pages/parameters/Organisation";
import { flutterColorToHex } from "../config/theme";

const ListCell = ({
  user,
  removable,
  onRemove,
  setMemberOpen,
  canopen = false,
  show_id = false,
}) => {
  return (
    <div className="flex items-center  w-full border-b border-gray-200">
      {/* User Avatar and Email */}
      <div className="w-8 h-8 flex items-center justify-center">
        <Icon1
          icon_name={user.org_admin ? "admin" : "user"}
          size={20}
          fill={user.org_admin ? "black" : "grey"}
        />
      </div>
      <div className=" w-c200 ">
        <div
          className={`rounded-xl ${user.role === "operator" ? "bg-orange-100" : user.role === "respo" ? "bg-green-100" : user.role === "conductor" ? "bg-red-100" : user.role === "secretary" ? "bg-blue-100" : "bg-transparent"} w-fit  px-2 py-0.5 text-h3 text-shadow_50`}
        >
          {getRoleString(user.role)}
        </div>
      </div>
      <div className="flex items-center w-c200">
        <span className="text-h3">{user.display_name}</span>
      </div>
      <div className="flex items-center flex-grow">
        <span className="text-h3">{user.email}</span>
      </div>{" "}
      {show_id && (
        <div className="flex items-center flex-grow">
          <span className="text-h3">{user.id}</span>
        </div>
      )}
      <div className="flex flex-row  flex-grow justify-end items-center gap-2 pr-2">
        {/* Close Icon (Removable functionality) */}
        {removable && (
          <div
            className="flex justify-end items-center cursor-pointer"
            onClick={() => onRemove(user.id)}
          >
            <Icon1
              icon_name="close"
              height="16px"
              width="16px"
              fill="#FF0000"
            />
          </div>
        )}
        {canopen && (
          <div
            className="flex justify-end items-center cursor-pointer"
            onClick={() => setMemberOpen(user.id)}
          >
            <Icon1 icon_name="settings" size={20} fill="grey" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListCell;
